<div class="mainclass landing-page">
  <div class="root responsivegrid">
    <div
      class="responsivegrid aem-GridColumn--default--none aem-GridColumn aem-GridColumn--default--12 aem-GridColumn--offset--default--0">
      <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
        <div class="banner aem-GridColumn aem-GridColumn--default--12">
          <div class="container-fluid">

            <input type="hidden" id="trigger-element" name="trigger-element"
              value="Repayments calculator" />
            <section>
              <div class="row image-banner-container themebg">
                <div
                  class="nbd-img-banner col-12 col-sm-6 col-md-6 col-lg-6 img-align pl-0 pr-0 shadow-box">
                  <figure class="nbd-banner-img banner-bgimage " alt="happy-family-travelling-in-car">
                  </figure>

                </div>
                @if (status === 'completed') {
                  <div
                    class="col-12 col-sm-6 col-md-6 col-lg-6 nbd-banner-content">
                    <div class="col-12 p-0">
                      <div class="nbd-banner-details offset-md-1">
                        <h1>
                          You’re one step
                          <span>closer to achieving your study goals.</span>
                        </h1>
                        <p>We've received your details and a Nedbank consultant will give you a call
                          soon to complete your application and guide you through the next steps.
                        Please keep your phone nearby so you don’t miss the call.</p>
                        <div class="nbd-btn-row-in-banner">
                          <div class="col-12 nbd-banner-buttons ">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (status === 'rejected') {
                  <div
                    class="col-12 col-sm-6 col-md-6 col-lg-6 nbd-banner-content">
                    <div class="col-12 p-0">
                      <div class="nbd-banner-details offset-md-1">
                        <h1>
                          Unfortunately you don't qualify
                          <span>for a Nedbank Education Loan</span>
                        </h1>
                        <p>In order to qualify for a Nedbank Education Loan you need to earn an
                        income of R 5 000 or more per month. </p>
                        <div class="nbd-btn-row-in-banner">
                          <div class="col-12 nbd-banner-buttons ">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>